module.exports = __webpack_public_path__ + "static/media/person.badd7f4f.svg";